var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-col',[_c('v-row',{attrs:{"no-gutters":"","align":"center","justify":"center"}},[_c('p',{staticClass:"grey--text"},[_vm._v(_vm._s(_vm.name))])]),_c('v-row',{attrs:{"no-gutters":"","align":"center","justify":"center"}},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.uid))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }